module.exports = __webpack_public_path__ + "img/kong3.e59ffdc3.png";